import { Link } from "react-router-dom";
import { leakCategories } from "@/mocks/leaks";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="wrap grid grid-cols-1 gap-10 py-12 md:grid-cols-12 md:py-16">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded bg-primary-500 font-heading text-lg font-bold text-background-50">
              深
            </span>
            <span className="font-heading text-lg font-bold text-background-50">深夜爆料</span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200">
            一个为线人、知情者与内部来源准备的匿名线索入口。我们把碎片化的投稿整理成可核对的条目，标注来源与可信等级，让每一条信息都有据可查。
          </p>
          <p className="mt-5 font-label text-xs tracking-[0.25em] text-accent-300">
            夜班编辑室 · 00:00 — 06:00 值守
          </p>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
            线索分类
          </h3>
          <ul className="mt-4 space-y-2">
            {leakCategories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/leaks?cat=${cat.slug}`}
                  className="font-label text-sm text-background-200 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
            站点导航
          </h3>
          <ul className="mt-4 space-y-2">
            <li>
              <Link to="/" className="font-label text-sm text-background-200 transition-colors hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/leaks" className="font-label text-sm text-background-200 transition-colors hover:text-accent-300">
                线索库
              </Link>
            </li>
            <li>
              <Link to="/about" className="font-label text-sm text-background-200 transition-colors hover:text-accent-300">
                关于本站
              </Link>
            </li>
            <li>
              <Link to="/#submit" className="font-label text-sm text-background-200 transition-colors hover:text-accent-300">
                匿名投稿
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
            联系我们
          </h3>
          <ul className="mt-4 space-y-3 font-label text-sm text-background-200">
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-line" />
              </span>
              tips@midnight-leaks.example.com
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                <i className="ri-shield-check-line" />
              </span>
              来源信息默认脱敏
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="wrap flex flex-col gap-3 py-6 font-label text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 深夜爆料编辑室 · 内容仅供信息参考，请以事实核查为准</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="whitespace-nowrap">匿名投稿通道全天开放</span>
            <span className="whitespace-nowrap">来源保护优先</span>
          </p>
        </div>
      </div>
    </footer>
  );
}